export default __webpack_public_path__ + "85f71b723441bcf428b8abed1fc8f56f.js";